import { PreloadableRouteObject, TFileToRouteMap } from '~/app/models'
import { getRoutesFromMap } from '~/app/utils/lazy'
import { EMarketingClientPath } from '~/models/api'

export const marketingRoutesFileToRouteMap: TFileToRouteMap = {
  examplePage: {
    path: EMarketingClientPath.examplePage,
    getImportPromise: () => import('~/pages/examplePage'),
  },
  faq: {
    path: EMarketingClientPath.faq,
    getImportPromise: () => import('~/pages/faq'),
  },
  home: {
    path: EMarketingClientPath.home,
    getImportPromise: () => import('~/pages/home'),
  },
  homeAppointment: {
    path: EMarketingClientPath.homeAppointment,
    getImportPromise: () => import('~/pages/homeAppointment'),
  },
  homeGym: {
    path: EMarketingClientPath.homeGym,
    getImportPromise: () => import('~/pages/homeGym'),
  },
  howItWorks: {
    path: EMarketingClientPath.about,
    getImportPromise: () => import('~/pages/howItWorks'),
  },
  integrations: {
    path: EMarketingClientPath.marketingIntegrations,
    getImportPromise: () => import('~/pages/integrations'),
  },
  loadingItem: {
    path: EMarketingClientPath.loadingItem,
    getImportPromise: () => import('~/pages/loadingItem'),
  },
  payments: {
    path: EMarketingClientPath.payments,
    getImportPromise: () => import('~/pages/payments'),
  },
  facebookDemo: {
    path: EMarketingClientPath.facebookDemo,
    getImportPromise: () => import('~/pages/playground/facebookDemo'),
  },
  playground: {
    path: EMarketingClientPath.playground,
    getImportPromise: () => import('~/pages/playground'),
  },
  pricing: {
    path: EMarketingClientPath.pricing,
    getImportPromise: () => import('~/pages/pricing'),
  },
  privacyPolicy: {
    path: EMarketingClientPath.marketingPrivacyPolicy,
    getImportPromise: () => import('~/pages/privacyPolicy'),
  },
  product: {
    path: EMarketingClientPath.product,
    getImportPromise: () => import('~/pages/product'),
  },
  referrals: {
    path: EMarketingClientPath.referral,
    getImportPromise: () => import('~/pages/referrals'),
  },
  referralsAbout: {
    path: EMarketingClientPath.referralsAbout,
    getImportPromise: () => import('~/pages/referrals/referralsAbout'),
  },
  referralLink: {
    path: EMarketingClientPath.referralLink,
    getImportPromise: () => import('~/pages/referrals/referralRedirect'),
  },
  referralsTerms: {
    path: EMarketingClientPath.marketingReferralsTerms,
    getImportPromise: () => import('~/pages/referrals/referralsTerms'),
  },
  whoWeHelpGymPage: {
    path: EMarketingClientPath.whoWeHelpGym,
    getImportPromise: () => import('~/pages/whoWeHelp/whoWeHelpGymPage'),
  },
  whoWeHelpRecreationFacilitiesPage: {
    path: EMarketingClientPath.whoWeHelpRecreationFacilities,
    getImportPromise: () =>
      import('~/pages/whoWeHelp/whoWeHelpRecFacilityPage'),
  },
  whoWeHelpSpasPage: {
    path: EMarketingClientPath.whoWeHelpSpas,
    getImportPromise: () => import('~/pages/whoWeHelp/whoWeHelpSpaPage'),
  },
  whoWeHelpMovementPage: {
    path: EMarketingClientPath.whoWeHelpMartialArtsDanceMovement,
    getImportPromise: () => import('~/pages/whoWeHelp/whoWeHelpMovementPage'),
  },
  whoWeHelpOtherPage: {
    path: EMarketingClientPath.whoWeHelpOther,
    getImportPromise: () => import('~/pages/whoWeHelp/whoWeHelpOtherPage'),
  },
  whoWeHelpWhiteLabelPage: {
    path: EMarketingClientPath.whoWeHelpWhiteLabel,
    getImportPromise: () => import('~/pages/whoWeHelp/whoWeHelpWhiteLabelPage'),
  },
  supportAndContact: {
    path: EMarketingClientPath.supportAndContact,
    getImportPromise: () => import('~/pages/supportAndContact'),
  },
  termsOfUse: {
    path: EMarketingClientPath.marketingTermsOfUse,
    getImportPromise: () => import('~/pages/termsOfUse'),
  },
}

const marketingRoutes: PreloadableRouteObject[] = getRoutesFromMap(
  marketingRoutesFileToRouteMap,
)

export default marketingRoutes
